/* Black Deal Friday card game (snippets/black-friday-game.liquid renders the markup + #MyBjConfig). Loaded with defer. */
(() => {
  const cfg = JSON.parse(document.getElementById('MyBjConfig').textContent);
  if (Date.now() > Date.parse(cfg.endsAt)) return;

  const KEY = 'myBlackFridayBj';
  const demo = cfg.prizes.every((p) => !p.variantId);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wait = (ms) => new Promise((r) => setTimeout(r, reduced ? 0 : ms));

  // Language + currency: storefront locale/market, falling back to English / RON.
  const T = {
    ro: {
      name: 'Black Deal Friday', fab: 'Black Deal Friday', close: 'Închide', q: ['„', '”'], 
      introTitle: 'Bate dealerul', introText: 'Ajungi cât mai aproape de 21, fără să treci peste. La egalitate câștigi tu.<br>Dacă câștigi, primești un <b>premiu surpriză</b>, gratuit în comanda ta.',
      deal: 'Împarte cărțile', tries: (n, max) => n === max ? `Ai ${max} încercări` : `Mai ai ${n} din ${max} încercări`,
      rules: (d) => `Premiul intră gratuit în orice comandă cu cel puțin un produs, plasată până pe ${d}, cât timp există stoc.`, terms: 'Regulament',
      dealer: 'Dealer', you: 'Tu', dealing: 'Se împart cărțile…', more: 'Mai vrei o carte?', risky: 'Riști încă una?',
      stand: 'Stau', hit: 'Încă o carte', dealerDraws: 'Dealerul trage…',
      win: 'Ai câștigat!', dealerBust: 'Dealerul a trecut de 21', beat: 'L-ai bătut pe dealer', seePrize: 'Vezi premiul',
      checking: 'Se verifică…', declined: 'Ai scos premiul din coș.', readd: 'Adaugă-l înapoi', push: 'Egal', tieWin: 'Egalitate · la egal câștigi tu', pushStatus: 'Nimeni nu câștigă · mai joci o mână', again: 'Încă o mână',
      bust: 'Peste 21', dealerWins: 'Dealerul câștigă', left: (n) => n === 1 ? 'Mai ai o încercare' : `Mai ai ${n} încercări`,
      none: 'Nu mai ai încercări · mulțumim că ai jucat', retry: 'Mai încearcă',
      pickTitle: 'Ai câștigat<br>Vitamin Aqua Socks!', pick: 'Alege modelul:', gone: 'Modelul ales tocmai s-a epuizat. Alege altul:',
      doneTitle: 'Premiul tău', reserved: (d) => `Rezervate pentru tine până pe ${d}.`, inCart: 'În coșul tău, gratuit.',
      barMissing: 'Adaugă <b>orice produs</b> în coș și premiul intră gratuit în comandă.', barOk: '<b>Gata!</b> Premiul e în coșul tău, gratuit.',
      shop: 'Continuă cumpărăturile', cart: 'Mergi la coș', auto: 'Premiul intră automat în coș odată cu primul produs.',
      allGone: 'Premiile s-au terminat. Mulțumim că ai jucat!', thanksTitle: 'Mulțumim!', thanksText: 'Ai folosit toate încercările. Ne vedem la următorul joc.',
      share: 'Provoacă-ți prietenii', shareChat: 'Trimite prietenilor', shareStory: 'Distribuie în story', shareImg: ['Am bătut', 'dealerul'], shareCta: 'Joacă și tu pe', shareSub: (d) => `Bate dealerul și câștigă un premiu surpriză · până pe ${d}`, shareText: 'Am bătut dealerul la MY Black Deal Friday 🖤 Joacă și tu și câștigă un premiu surpriză:', shareFallback: 'Trimite imaginea prietenilor:', download: 'Descarcă imaginea', copy: 'Copiază linkul', copied: 'Link copiat!',
      email: 'Adresa ta de email', emailNote: 'Ca să joci, te abonezi la newsletter-ul MY. Te poți dezabona oricând.', emailError: 'Scrie o adresă de email validă.'
    },
    en: {
      name: 'Black Deal Friday', fab: 'Black Deal Friday', close: 'Close', q: ['“', '”'], 
      introTitle: 'Beat the dealer', introText: 'Get as close to 21 as you can without going over. Ties go to you.<br>Win and you get a <b>surprise gift</b>, free with your order.',
      deal: 'Deal the cards', tries: (n, max) => n === max ? `You have ${max} tries` : `${n} of ${max} tries left`,
      rules: (d) => `The gift is added free to any order with at least one product, placed by ${d}, while stocks last.`, terms: 'Terms',
      dealer: 'Dealer', you: 'You', dealing: 'Dealing…', more: 'Another card?', risky: 'Risk one more?',
      stand: 'Stand', hit: 'Hit me', dealerDraws: 'Dealer draws…',
      win: 'You won!', dealerBust: 'The dealer went over 21', beat: 'You beat the dealer', seePrize: 'See your gift',
      checking: 'Checking…', declined: 'You removed the gift from your cart.', readd: 'Add it back', push: 'Tie', tieWin: 'A tie · ties go to you', pushStatus: 'Nobody wins · play another hand', again: 'Another hand',
      bust: 'Over 21', dealerWins: 'Dealer wins', left: (n) => n === 1 ? '1 try left' : `${n} tries left`,
      none: 'No tries left · thanks for playing', retry: 'Try again',
      pickTitle: 'You won<br>Vitamin Aqua Socks!', pick: 'Choose your style:', gone: 'That style just sold out. Pick another one:',
      doneTitle: 'Your gift', reserved: (d) => `Reserved for you until ${d}.`, inCart: 'In your cart, free.',
      barMissing: 'Add <b>any product</b> to your cart and the gift joins your order for free.', barOk: '<b>Done!</b> Your gift is in your cart, free.',
      shop: 'Continue shopping', cart: 'Go to cart', auto: 'The gift is added to your cart automatically with your first product.',
      allGone: 'All gifts are gone. Thanks for playing!', thanksTitle: 'Thank you!', thanksText: 'You have used all your tries. See you at the next game.',
      share: 'Challenge your friends', shareChat: 'Send to friends', shareStory: 'Share to story', shareImg: ['I beat', 'the dealer'], shareCta: 'Play now at', shareSub: (d) => `Beat the dealer and win a surprise gift · until ${d}`, shareText: 'I beat the dealer at MY Black Deal Friday 🖤 Play and win a surprise gift:', shareFallback: 'Send the image to your friends:', download: 'Download image', copy: 'Copy link', copied: 'Link copied!',
      email: 'Your email address', emailNote: 'To play, you subscribe to the MY newsletter. You can unsubscribe anytime.', emailError: 'Please enter a valid email address.'
    },
    de: {
      name: 'Black Deal Friday', fab: 'Black Deal Friday', close: 'Schließen', q: ['„', '“'], 
      introTitle: 'Schlag den Dealer', introText: 'Komm so nah wie möglich an 21, ohne drüber zu gehen. Bei Gleichstand gewinnst du.<br>Gewinnst du, bekommst du ein <b>Überraschungsgeschenk</b>, gratis zu deiner Bestellung.',
      deal: 'Karten austeilen', tries: (n, max) => n === max ? `Du hast ${max} Versuche` : `Noch ${n} von ${max} Versuchen`,
      rules: (d) => `Das Geschenk kommt gratis zu jeder Bestellung mit mindestens einem Produkt bis ${d}., solange der Vorrat reicht.`, terms: 'Teilnahmebedingungen',
      dealer: 'Dealer', you: 'Du', dealing: 'Karten werden ausgeteilt…', more: 'Noch eine Karte?', risky: 'Noch eine riskieren?',
      stand: 'Halten', hit: 'Noch eine', dealerDraws: 'Der Dealer zieht…',
      win: 'Gewonnen!', dealerBust: 'Der Dealer hat über 21', beat: 'Du hast den Dealer geschlagen', seePrize: 'Zum Geschenk',
      checking: 'Wird geprüft…', declined: 'Du hast das Geschenk entfernt.', readd: 'Wieder hinzufügen', push: 'Unentschieden', tieWin: 'Gleichstand · der geht an dich', pushStatus: 'Niemand gewinnt · noch eine Runde', again: 'Noch eine Runde',
      bust: 'Über 21', dealerWins: 'Dealer gewinnt', left: (n) => n === 1 ? 'Noch 1 Versuch' : `Noch ${n} Versuche`,
      none: 'Keine Versuche mehr · danke fürs Spielen', retry: 'Nochmal',
      pickTitle: 'Du hast Vitamin Aqua Socks gewonnen!', pick: 'Wähle dein Modell:', gone: 'Dieses Modell ist gerade ausverkauft. Wähle ein anderes:',
      doneTitle: 'Dein Geschenk', reserved: (d) => `Für dich reserviert bis ${d}.`, inCart: 'Gratis in deinem Warenkorb.',
      barMissing: 'Leg <b>ein beliebiges Produkt</b> in den Warenkorb und das Geschenk kommt gratis dazu.', barOk: '<b>Fertig!</b> Dein Geschenk ist gratis im Warenkorb.',
      shop: 'Weiter einkaufen', cart: 'Zum Warenkorb', auto: 'Das Geschenk kommt mit deinem ersten Produkt automatisch in den Warenkorb.',
      allGone: 'Alle Geschenke sind vergeben. Danke fürs Spielen!', thanksTitle: 'Danke!', thanksText: 'Du hast alle Versuche genutzt. Bis zum nächsten Spiel.',
      share: 'Fordere deine Freunde heraus', shareChat: 'An Freunde senden', shareStory: 'In Story teilen', shareImg: ['Dealer', 'geschlagen'], shareCta: 'Jetzt spielen auf', shareSub: (d) => `Schlag den Dealer und gewinne ein Überraschungsgeschenk · bis ${d}.`, shareText: 'Ich habe den Dealer bei MY Black Deal Friday geschlagen 🖤 Spiel mit und gewinne ein Überraschungsgeschenk:', shareFallback: 'Schick das Bild deinen Freunden:', download: 'Bild speichern', copy: 'Link kopieren', copied: 'Link kopiert!',
      email: 'Deine E-Mail-Adresse', emailNote: 'Zum Spielen meldest du dich für den MY Newsletter an. Abmeldung jederzeit möglich.', emailError: 'Bitte gib eine gültige E-Mail-Adresse ein.'
    }
  };
  const lang = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2);
  const t = T[lang] || T.en;
  // Prize variants still in stock (rendered by Liquid; null = unknown → treat all as available).
  const inStock = (p) => !Array.isArray(cfg.available) || cfg.available.includes(p.variantId);
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} };
  const state = Object.assign({ losses: 0, won: false, prize: null, email: null }, load());
  // Email gate (newsletter signup before the first deal); off since 31.10 — most shoppers closed the game at that step.
  const askEmail = () => cfg.requireEmail !== false && !state.email;
  const triesLeft = () => cfg.maxLosses - state.losses;
  // All prizes gone → no new games (a winner still keeps the cart sync for the prize they hold).
  if (!cfg.prizes.some(inStock) && !state.won) return;

  const SUITS = {
    spade: { red: false, svg: '<path d="M12 2C9 6 4 9 4 13.2 4 15.9 6 18 8.5 18c1.3 0 2.4-.5 3-1.3-.2 2-1 3.6-2.5 5.3h6c-1.5-1.7-2.3-3.3-2.5-5.3.6.8 1.7 1.3 3 1.3 2.5 0 4.5-2.1 4.5-4.8C20 9 15 6 12 2z"/>' },
    heart: { red: true, svg: '<path d="M12 21s-8.5-5.3-8.5-11.3C3.5 6.6 5.8 4.5 8.4 4.5c1.6 0 2.9.8 3.6 2 .7-1.2 2-2 3.6-2 2.6 0 4.9 2.1 4.9 5.2C20.5 15.7 12 21 12 21z"/>' },
    club: { red: false, svg: '<circle cx="12" cy="7" r="4"/><circle cx="7" cy="13" r="4"/><circle cx="17" cy="13" r="4"/><path d="M11 12h2c0 4 .8 6.5 2.5 10h-7c1.7-3.5 2.5-6 2.5-10z"/>' },
    diamond: { red: true, svg: '<path d="M12 2l7 10-7 10-7-10z"/>' }
  };
  const RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
  const icon = (s) => `<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">${SUITS[s].svg}</svg>`;

  // Analytics: Clarity custom event + Shopify customer event (counted later: Clarity dashboard / GA4 ?ref=share visits).
  // Funnel: mybj_open → mybj_email → (mybj_captcha) → mybj_email_ok|timeout → mybj_win | mybj_lose / mybj_lose_final → mybj_prize_pick.
  const track = (name) => {
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, {}); } catch (e) {}
  };
  const fab = document.getElementById('MyBjFab');
  const signupForm = document.getElementById('MyBjSignup');
  if (signupForm) {
    // Enter in the email field = deal; the real submit only happens from signUp().
    signupForm.addEventListener('submit', (e) => { if (!signupForm.dataset.go) { e.preventDefault(); signUp(); } });
  }
  const overlay = document.getElementById('MyBjOverlay');
  const screen = document.getElementById('MyBjScreen');
  let deck, player, dealer, busy = false;

  const newDeck = () => {
    const d = [];
    Object.keys(SUITS).forEach((s) => RANKS.forEach((r) => d.push({ r, s })));
    for (let i = d.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [d[i], d[j]] = [d[j], d[i]]; }
    return d;
  };
  const score = (hand) => {
    let total = 0, aces = 0;
    hand.forEach((c) => { if (c.r === 'A') { aces++; total += 11; } else total += ['J', 'Q', 'K'].includes(c.r) ? 10 : Number(c.r); });
    while (total > 21 && aces) { total -= 10; aces--; }
    return total;
  };
  const isBlackjack = (hand) => hand.length === 2 && score(hand) === 21;

  const cardEl = (c, down) => {
    const el = document.createElement('div');
    el.className = 'mybj-card' + (down ? ' is-down' : '');
    el.innerHTML = `<div class="mybj-card__inner">
      <div class="mybj-card__face mybj-card__front${c && SUITS[c.s].red ? ' is-red' : ''}">${c ? `
        <span class="mybj-card__rank mybj-card__rank--tl">${c.r}${icon(c.s)}</span>
        <svg class="mybj-card__pip" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">${SUITS[c.s].svg}</svg>
        <span class="mybj-card__rank mybj-card__rank--br">${c.r}${icon(c.s)}</span>` : ''}</div>
      <div class="mybj-card__face mybj-card__back"><b>MY</b></div></div>`;
    return el;
  };
  const setFront = (el, c) => {
    const fresh = cardEl(c, true);
    el.querySelector('.mybj-card__front').replaceWith(fresh.querySelector('.mybj-card__front'));
  };

  // Lay out a hand as an overlapping fan centred in its row.
  const layout = (handEl) => {
    const cards = [...handEl.children];
    const w = handEl.clientWidth, cw = cards[0] ? cards[0].offsetWidth : 64;
    const step = Math.min(cw * 0.62, (w - cw) / Math.max(1, cards.length - 1));
    const start = (w - (cw + step * (cards.length - 1))) / 2;
    cards.forEach((el, i) => {
      const tilt = (i - (cards.length - 1) / 2) * 3;
      el.style.transition = 'transform .35s cubic-bezier(.2,.8,.2,1)';
      el.style.transform = `translate(${start + step * i}px, ${Math.abs(tilt) * 0.8}px) rotate(${tilt}deg)`;
    });
  };

  // Fly a card from the shoe into a hand, flipping face-up on the way unless it's the hole card.
  const dealTo = async (handEl, c, down) => {
    const table = screen.querySelector('.mybj-table');
    const shoe = table.querySelector('.mybj-shoe').getBoundingClientRect();
    const el = cardEl(c, true);
    handEl.appendChild(el);
    layout(handEl);
    const end = el.style.transform;
    const box = handEl.getBoundingClientRect();
    el.style.transition = 'none';
    el.style.transform = `translate(${shoe.left - box.left}px, ${shoe.top - box.top}px) rotate(-14deg)`;
    el.getBoundingClientRect();
    el.style.transition = reduced ? 'none' : 'transform .42s cubic-bezier(.2,.8,.2,1)';
    el.style.transform = end;
    await wait(220);
    if (!down) el.classList.remove('is-down');
    await wait(260);
    return el;
  };

  const setScore = (who, hand, hidden) => {
    const el = screen.querySelector(`[data-mybj-score="${who}"]`);
    const v = hidden ? score([hand[0]]) : score(hand);
    el.textContent = hidden ? v + ' + ?' : v;
    el.classList.toggle('is-21', !hidden && v === 21);
    el.classList.toggle('is-bust', v > 21);
    el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
  };
  const status = (t) => { screen.querySelector('.mybj-status').textContent = t; };
  const actions = (html) => { screen.querySelector('.mybj__actions').innerHTML = html; };

  const confetti = (n) => {
    if (reduced) return;
    const fx = screen.querySelector('.mybj-fx') || screen.closest('.mybj').appendChild(Object.assign(document.createElement('div'), { className: 'mybj-fx' }));
    const keys = Object.keys(SUITS);
    for (let i = 0; i < n; i++) {
      const s = keys[i % keys.length];
      const span = document.createElement('span');
      span.innerHTML = icon(s);
      const svg = span.firstChild;
      svg.style.left = Math.random() * 100 + '%';
      svg.style.color = SUITS[s].red ? cfg.red : '#000';
      fx.appendChild(svg);
      svg.animate([
        { transform: `translateY(0) rotate(0deg)`, opacity: 1 },
        { transform: `translate(${(Math.random() - .5) * 120}px, ${500 + Math.random() * 200}px) rotate(${(Math.random() - .5) * 720}deg)`, opacity: .9 }
      ], { duration: 1400 + Math.random() * 1000, delay: Math.random() * 400, easing: 'cubic-bezier(.3,.5,.6,1)', fill: 'forwards' })
        .finished.then(() => svg.remove());
    }
  };

  const banner = (text, lose) => {
    const b = document.createElement('div');
    b.className = 'mybj-banner' + (lose ? ' mybj-banner--lose' : '');
    b.innerHTML = `<span class="mybj-blob">${text}</span>`;
    screen.querySelector('.mybj-table').appendChild(b);
    b.firstChild.animate([{ transform: 'scale(.3) rotate(-12deg)', opacity: 0 }, { transform: 'scale(1.12) rotate(3deg)', opacity: 1, offset: .7 }, { transform: 'scale(1) rotate(-2deg)', opacity: 1 }],
      { duration: reduced ? 1 : 480, easing: 'cubic-bezier(.2,.9,.3,1.2)', fill: 'forwards' });
  };
  const shake = (handEl) => handEl.animate([{ transform: 'none' }, { transform: 'translateX(-8px)' }, { transform: 'translateX(7px)' }, { transform: 'translateX(-4px)' }, { transform: 'none' }], { duration: reduced ? 1 : 380 });

  /* Screens */
  const renderIntro = () => {
    screen.innerHTML = `
      <div class="mybj-fan"></div>
      <h2 class="mybj__title mybj-blob">${t.introTitle}</h2>
      <p class="mybj__text">${t.introText}</p>
      ${!askEmail() ? '' : `<div data-mybj-form-slot></div>
        <p class="mybj-email__error" data-mybj-error hidden>${t.emailError}</p>`}
      <div class="mybj__actions"><button type="button" class="mybj-btn" data-mybj-deal>${t.deal}</button></div>
      ${!askEmail() ? '' : `<p class="mybj__small">${t.emailNote}</p>`}
      <p class="mybj__small">${t.tries(triesLeft(), cfg.maxLosses)} · ${t.rules(cfg.until)} <a href="${root}pages/${cfg.termsPage}" style="color:inherit">${t.terms}</a></p>`;
    const slot = screen.querySelector('[data-mybj-form-slot]');
    if (slot && signupForm) slot.replaceWith(signupForm);
    const fan = screen.querySelector('.mybj-fan');
    Object.keys(SUITS).forEach((s, i) => {
      const el = cardEl({ r: 'A', s }, true);
      fan.appendChild(el);
      const rot = (i - 1.5) * 14;
      el.animate([{ transform: 'translateY(60px) rotate(0deg)', opacity: 0 }, { transform: `translate(${(i - 1.5) * 26}px, ${Math.abs(i - 1.5) * 6}px) rotate(${rot}deg)`, opacity: 1 }],
        { duration: reduced ? 1 : 520, delay: reduced ? 0 : 120 + i * 90, easing: 'cubic-bezier(.2,.9,.3,1.25)', fill: 'forwards' });
      setTimeout(() => el.classList.remove('is-down'), reduced ? 0 : 420 + i * 90);
    });
  };

  const renderTable = () => {
    screen.innerHTML = `
      <div class="mybj-table">
        <div class="mybj-shoe">${'<div class="mybj-card is-down"><div class="mybj-card__inner"><div class="mybj-card__face mybj-card__back"><b>MY</b></div></div></div>'.repeat(3)}</div>
        <div class="mybj-table__row"><p>${t.dealer}</p><span class="mybj-score" data-mybj-score="dealer">0</span></div>
        <div class="mybj-hand" data-mybj-hand="dealer"></div>
        <div class="mybj-table__row"><p>${t.you}</p><span class="mybj-score" data-mybj-score="player">0</span></div>
        <div class="mybj-hand" data-mybj-hand="player"></div>
        <p class="mybj-status" aria-live="polite"></p>
      </div>
      <div class="mybj__actions"></div>`;
  };

  const playActions = () => actions(`<button type="button" class="mybj-btn mybj-btn--ghost" data-mybj-stand>${t.stand}</button><button type="button" class="mybj-btn" data-mybj-hit>${t.hit}</button>`);

  const deal = async () => {
    busy = true;
    deck = newDeck(); player = []; dealer = [];
    renderTable();
    const pH = screen.querySelector('[data-mybj-hand="player"]'), dH = screen.querySelector('[data-mybj-hand="dealer"]');
    status(t.dealing);
    player.push(deck.pop()); await dealTo(pH, player[0]); setScore('player', player);
    dealer.push(deck.pop()); await dealTo(dH, dealer[0]); setScore('dealer', dealer, true);
    player.push(deck.pop()); await dealTo(pH, player[1]); setScore('player', player);
    dealer.push(deck.pop()); await dealTo(dH, dealer[1], true);
    busy = false;
    if (isBlackjack(player) || isBlackjack(dealer)) return finish();
    status(t.more);
    playActions();
  };

  const hit = async () => {
    busy = true; actions('');
    const pH = screen.querySelector('[data-mybj-hand="player"]');
    player.push(deck.pop()); await dealTo(pH, player[player.length - 1]); setScore('player', player);
    busy = false;
    if (score(player) > 21) { shake(pH); return finish(); }
    if (score(player) === 21) return finish();
    status(score(player) >= 17 ? t.risky : t.more);
    playActions();
  };

  const finish = async () => {
    busy = true; actions('');
    const dH = screen.querySelector('[data-mybj-hand="dealer"]'), pH = screen.querySelector('[data-mybj-hand="player"]');
    const hole = dH.children[1];
    await wait(300);
    hole.classList.remove('is-down');
    setScore('dealer', dealer);
    await wait(500);
    const p = score(player);
    if (p <= 21 && !isBlackjack(player)) {
      while (score(dealer) < 17) {
        status(t.dealerDraws);
        await wait(450);
        dealer.push(deck.pop()); await dealTo(dH, dealer[dealer.length - 1]); setScore('dealer', dealer);
        await wait(250);
      }
    }
    const d = score(dealer);
    let outcome;
    if (p > 21) outcome = 'bust';
    else if (isBlackjack(player) && !isBlackjack(dealer)) outcome = 'blackjack';
    else if (isBlackjack(dealer) && !isBlackjack(player)) outcome = 'lose';
    else if (d > 21) outcome = 'dealer-bust';
    else if (p > d) outcome = 'win';
    else if (p === d) outcome = 'tie';
    else outcome = 'lose';
    busy = false;

    if (['blackjack', 'dealer-bust', 'win', 'tie'].includes(outcome)) {
      state.won = true; save();
      track('mybj_win');
      banner(outcome === 'blackjack' ? '21!' : t.win);
      if (outcome === 'dealer-bust') shake(dH);
      confetti(28);
      status(outcome === 'dealer-bust' ? t.dealerBust : outcome === 'tie' ? t.tieWin : t.beat);
      await wait(900);
      actions(`<button type="button" class="mybj-btn" data-mybj-prize>${t.seePrize}</button>`);
    } else if (outcome === 'push') {
      banner(t.push);
      status(t.pushStatus);
      actions(`<button type="button" class="mybj-btn" data-mybj-deal>${t.again}</button>`);
    } else {
      state.losses++; save();
      track(triesLeft() > 0 ? 'mybj_lose' : 'mybj_lose_final');
      banner(outcome === 'bust' ? t.bust : t.dealerWins, true);
      status(triesLeft() > 0 ? t.left(triesLeft()) : t.none);
      actions(triesLeft() > 0
        ? `<button type="button" class="mybj-btn" data-mybj-deal>${t.retry}</button>`
        : `<button type="button" class="mybj-btn mybj-btn--ghost" data-mybj-close>${t.close}</button>`);
    }
  };

  const renderPrizePick = (gone) => {
    const left = cfg.prizes.map((p, i) => [p, i]).filter(([p]) => inStock(p));
    if (!left.length) { screen.innerHTML = `<h2 class="mybj__title mybj-blob">${t.thanksTitle}</h2><p class="mybj__text">${t.allGone}</p>`; return; }
    screen.innerHTML = `
      <h2 class="mybj__title mybj-blob" style="font-size:30px">${t.pickTitle}</h2>
      <p class="mybj__text">${gone ? t.gone : t.pick}</p>
      <div class="mybj-prizes">${left.map(([p, i]) => `
        <button type="button" class="mybj-prize" data-mybj-pick="${i}"><img src="${p.img}" alt="Vitamin Aqua ${p.code} Socks" width="300" height="450">${p.code}</button>`).join('')}
      </div>`;
    if (!gone) confetti(16);
  };

  const renderPrizeDone = (cart) => {
    const p = cfg.prizes[state.prize];
    const paid = hasPaid(cart);
    screen.innerHTML = `
      <h2 class="mybj__title mybj-blob" style="font-size:30px">${t.doneTitle}</h2>
      <div class="mybj-chosen"><img src="${p.img}" alt="" width="300" height="450">
        <p><strong>${t.q[0]}Vitamin Aqua ${p.code} Socks${t.q[1]}</strong>${paid ? t.inCart : t.reserved(cfg.until)}</p></div>
      ${state.declined ? `<p class="mybj__small" style="margin:0 0 12px">${t.declined} <a href="#" data-mybj-readd style="color:inherit">${t.readd}</a></p>` : `<div class="mybj-bar">${paid ? t.barOk : t.barMissing}</div>`}
      <div class="mybj__actions">
        <a class="mybj-btn" href="${root}${paid ? 'cart' : ''}">${paid ? t.cart : t.shop}</a>
      </div>
      <div class="mybj__actions mybj__actions--stack" style="margin-top:8px"><button type="button" class="mybj-btn" data-mybj-share="chat">💬 ${t.shareChat}</button></div>
      <div data-mybj-share-out></div>
      <p class="mybj__small">${t.auto}</p>`;
  };

  // Cart sync: the prize line is in the cart only while the cart holds at least one paid product.
  const getCart = () => demo ? Promise.resolve({ total_price: window.MyBjDemoTotal || 0, items: [] })
    : fetch(root + 'cart.js').then((r) => r.json());
  const prizeIds = cfg.prizes.map((p) => p.variantId);
  const hasPaid = (cart) => demo ? (cart.total_price || 0) > 0
    : cart.items.some((i) => !prizeIds.includes(i.variant_id) && i.final_line_price > 0);
  // Prize cart writes use a blank iframe's fetch: the page's fetch is wrapped by Shopify/pixel tracking,
  // which would log the 0-lei gift as "added to cart" (abandoned-cart emails, Meta/Google AddToCart).
  let quietFetch;
  const cartWrite = (path, body) => {
    if (!quietFetch) {
      try {
        const fr = document.createElement('iframe');
        fr.hidden = true; fr.tabIndex = -1; fr.setAttribute('aria-hidden', 'true');
        document.body.appendChild(fr);
        quietFetch = fr.contentWindow.fetch.bind(fr.contentWindow);
      } catch (e) { quietFetch = window.fetch.bind(window); }
    }
    return quietFetch(location.origin + root + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  };
  // Cart syncs run one after another: two overlapping syncs (double tap on two prizes, or a pick while the
  // cart-change resync runs) each saw no prize line and both added one → two gifts in the cart.
  let syncQueue = Promise.resolve();
  const syncCart = () => (syncQueue = syncQueue.then(syncCartNow, syncCartNow));
  const syncCartNow = async () => {
    const cart = await getCart();
    if (demo) return cart;
    const lines = cart.items.filter((i) => prizeIds.includes(i.variant_id));
    if (!lines.length && (!state.won || state.prize === null)) return cart;
    // A prize line without a won game on this device gets removed.
    const want = state.won && state.prize !== null ? cfg.prizes[state.prize].variantId : null;
    // We added it, it's gone and the cart still qualifies → the shopper removed it on purpose.
    if (want && state.inCart && !lines.length && hasPaid(cart)) { state.declined = true; state.inCart = false; save(); }
    const ok = want && !state.declined && hasPaid(cart);
    const updates = {};
    lines.forEach((l) => { if (!ok || l.variant_id !== want || l.quantity !== 1) updates[l.key] = ok && l.variant_id === want ? 1 : 0; });
    const needAdd = ok && !lines.some((l) => l.variant_id === want);
    if (!Object.keys(updates).length && !needAdd) { if (state.inCart !== !!(ok && lines.length)) { state.inCart = !!(ok && lines.length); save(); } return cart; }
    if (Object.keys(updates).length) {
      await cartWrite('cart/update.js', { updates });
    }
    if (needAdd) {
      const r = await cartWrite('cart/add.js', { items: [{ id: want, quantity: 1, properties: { _gift: 'black-friday' } }] });
      if (!r.ok) {
        // That style sold out since the page loaded → drop it and let the shopper pick another one.
        cfg.available = prizeIds.filter((id) => id !== want && inStock({ variantId: id }));
        state.prize = null; state.inCart = false; save();
        if (Object.keys(updates).length) await refreshCartUI();
        return Object.assign(await getCart(), { prizeGone: true });
      }
    }
    state.inCart = ok; save();
    await refreshCartUI();
    return getCart();
  };

  // Re-render the theme's cart drawer + cart bubble (or reload the cart page) after we changed the cart.
  const refreshCartUI = async () => {
    try {
      const itemsEl = document.getElementById('main-cart-items'), footerEl = document.getElementById('main-cart-footer');
      if (itemsEl && footerEl) {
        const ids = [itemsEl.dataset.id, footerEl.dataset.id];
        const html = await fetch(location.pathname + '?sections=' + ids.join(',') + ',cart-icon-bubble').then((r) => r.json());
        const pick = (h, sel) => { const el = new DOMParser().parseFromString(h, 'text/html').querySelector(sel); return el ? el.innerHTML : null; };
        [[itemsEl, ids[0]], [footerEl, ids[1]]].forEach(([el, id]) => {
          const target = el.querySelector('.js-contents') || el;
          const inner = html[id] && pick(html[id], `#${el.id} .js-contents`);
          if (inner !== null && inner !== undefined) target.innerHTML = inner;
        });
        const bubble = document.getElementById('cart-icon-bubble');
        const b = html['cart-icon-bubble'] && pick(html['cart-icon-bubble'], '.shopify-section');
        if (bubble && b) bubble.innerHTML = b;
        return;
      }
      const sections = await fetch(root + '?sections=cart-drawer,cart-icon-bubble').then((r) => r.json());
      const parse = (html, sel) => { const el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return el ? el.innerHTML : null; };
      const drawer = document.querySelector('#CartDrawer');
      const drawerHtml = sections['cart-drawer'] && parse(sections['cart-drawer'], '#CartDrawer');
      if (drawer && drawerHtml !== null) {
        drawer.innerHTML = drawerHtml;
        const inner = drawer.querySelector('.drawer__inner');
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && inner && !inner.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
        const overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && cartDrawer && cartDrawer.close) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
      }
      const bubble = document.getElementById('cart-icon-bubble');
      const bubbleHtml = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
    } catch (e) {}
  };

  const open = async () => {
    overlay.hidden = false;
    overlay.getBoundingClientRect();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.classList.add('mybj-open');
    document.documentElement.classList.remove('mybj-badge-off');
    track('mybj_open');
    if (state.won && state.prize !== null) { const cart = await syncCart(); if (cart.prizeGone) renderPrizePick(true); else renderPrizeDone(cart); }
    else if (state.won) renderPrizePick();
    else if (triesLeft() <= 0) screen.innerHTML = `<h2 class="mybj__title mybj-blob">${t.thanksTitle}</h2><p class="mybj__text">${t.thanksText}</p>`;
    else renderIntro();
  };
  // Share: a 1080×1920 story image drawn on canvas (brand font + the four aces) shared through the
  // system share sheet (Instagram, WhatsApp…); download / WhatsApp / copy-link fallback where it's unavailable.
  const shareUrl = 'https://mysimplicated.com' + root.replace(/\/$/, '') + '/?ref=share#black-friday';
  const svgImg = (svg) => new Promise((res) => { const i = new Image(); i.onload = () => res(i); i.onerror = () => res(null); i.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg); });
  // story = 9:16 (Instagram/WhatsApp status), chat = 4:5 (shows whole inside WhatsApp / DM bubbles).
  const LAYOUT = {
    story: { H: 1920, tag: 190, l1: 420, l2: 570, title: 150, cards: 1000, cs: 1, cta: 1450, dom: 1560, line: 1600, sub: 1690, my: 1830, mySize: 80 },
    chat: { H: 1350, tag: 110, l1: 270, l2: 390, title: 128, cards: 660, cs: 0.78, cta: 940, dom: 1035, line: 1070, sub: 1135, my: 0, mySize: 0 }
  };
  const drawPoster = async (format) => {
    const L = LAYOUT[format] || LAYOUT.story;
    const W = 1080, H = L.H, c = document.createElement('canvas');
    c.width = W; c.height = H;
    const g = c.getContext('2d');
    try { await document.fonts.load('120px MYSBlob'); } catch (e) {}
    g.fillStyle = '#0b0b0b'; g.fillRect(0, 0, W, H);
    g.textAlign = 'center';
    g.fillStyle = cfg.accent; g.font = '600 34px Helvetica, Arial, sans-serif';
    g.fillText((t.name + ' · 21').toUpperCase().split('').join(String.fromCharCode(8202)), W / 2, L.tag);
    // Shrink the wide brand font until each line fits inside the safe width.
    const fit = (txt, size, max, family) => { let px = size; do { g.font = `${px}px ${family}`; px -= 4; } while (g.measureText(txt).width > max && px > 20); };
    const blob = 'MYSBlob, Arial Black, sans-serif';
    g.fillStyle = '#fff';
    const l1 = t.shareImg[0].toUpperCase(), l2 = t.shareImg[1].toUpperCase();
    fit(l1.length > l2.length ? l1 : l2, L.title, 940, blob);
    g.fillText(l1, W / 2, L.l1);
    g.fillText(l2, W / 2, L.l2);
    const keys = Object.keys(SUITS);
    for (let i = 0; i < 4; i++) {
      const s = keys[i], col = SUITS[s].red ? cfg.red : '#000';
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="260" height="370" viewBox="0 0 260 370"><rect x="4" y="4" width="252" height="362" rx="18" fill="#fbfaf7"/><g transform="translate(70 125) scale(5)" fill="${col}">${SUITS[s].svg}</g><g transform="translate(26 92) scale(1.6)" fill="${col}">${SUITS[s].svg}</g></svg>`;
      const img = await svgImg(svg);
      g.save();
      g.translate(W / 2 + (i - 1.5) * 150 * L.cs, L.cards + Math.abs(i - 1.5) * 26 * L.cs);
      g.rotate((i - 1.5) * 0.24);
      g.scale(L.cs, L.cs);
      g.shadowColor = 'rgba(0,0,0,.6)'; g.shadowBlur = 40; g.shadowOffsetY = 18;
      if (img) g.drawImage(img, -130, -185, 260, 370);
      g.shadowColor = 'transparent';
      g.fillStyle = col; g.font = '64px MYSBlob, Arial Black, sans-serif'; g.textAlign = 'left';
      g.fillText('A', -108, -110);
      g.restore();
    }
    g.textAlign = 'center';
    g.fillStyle = 'rgba(255,255,255,.75)'; g.font = '44px Helvetica, Arial, sans-serif';
    g.fillText(t.shareCta, W / 2, L.cta);
    g.fillStyle = '#fff'; fit('MYSIMPLICATED.COM', 92, 940, blob);
    g.fillText('MYSIMPLICATED.COM', W / 2, L.dom);
    g.fillStyle = cfg.accent; g.fillRect(W / 2 - 90, L.line, 180, 8);
    g.fillStyle = 'rgba(255,255,255,.6)'; const sub = t.shareSub(cfg.until);
    fit(sub, 34, 960, 'Helvetica, Arial, sans-serif');
    g.fillText(sub, W / 2, L.sub);
    if (L.mySize) { g.fillStyle = '#fff'; g.font = `${L.mySize}px MYSBlob, Arial Black, sans-serif`; g.fillText('MY', W / 2, L.my); }
    return new Promise((res) => c.toBlob((b) => res(b), 'image/png'));
  };
  const copyLink = async (btn) => {
    try { await navigator.clipboard.writeText(shareUrl); } catch (e) {
      const ta = document.createElement('textarea'); ta.value = shareUrl; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e2) {} ta.remove();
    }
    btn.textContent = t.copied;
  };
  const shareWin = async (format) => {
    const out = screen.querySelector('[data-mybj-share-out]');
    track('mybj_share_' + format);
    const blob = await drawPoster(format);
    const file = blob && new File([blob], `my-black-friday-${format}.png`, { type: 'image/png' });
    const text = t.shareText + ' ' + shareUrl;
    if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
      try { await navigator.share({ files: [file], text }); return; } catch (e) { if (e && e.name === 'AbortError') return; }
    }
    if (!out) return;
    const url = blob ? URL.createObjectURL(blob) : '';
    out.innerHTML = `<div class="mybj-share">
      <p class="mybj__small" style="margin:0 0 10px">${t.shareFallback}</p>
      ${url ? `<img src="${url}" alt="" width="1080" height="1920">` : ''}
      <div class="mybj__actions">
        ${url ? `<a class="mybj-btn mybj-btn--ghost" href="${url}" download="my-black-friday-${format}.png">${t.download}</a>` : ''}
        <a class="mybj-btn mybj-btn--ghost" href="https://wa.me/?text=${encodeURIComponent(text)}" target="_blank" rel="noopener">WhatsApp</a>
      </div>
      <div class="mybj__actions" style="margin-top:8px"><a class="mybj-btn mybj-btn--ghost" href="#" data-mybj-copy>${t.copy}</a></div>
    </div>`;
  };

  // Email gate: subscribe through Shopify's newsletter (customer) form, tagged for this campaign.
  const signUp = () => {
    const input = screen.querySelector('[data-mybj-email]');
    const email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      screen.querySelector('[data-mybj-error]').hidden = false;
      input.focus();
      return;
    }
    state.email = email; save();
    track('mybj_email');
    if (demo || !signupForm) return deal();
    // A real Shopify customer form (rendered by Liquid) so the storefront CAPTCHA token is attached;
    // it posts into a hidden iframe so the shopper stays in the game. The form stays visible on this
    // screen until the post lands, so a CAPTCHA challenge (if any) is anchored to it and shows on-screen.
    const btn = screen.querySelector('[data-mybj-deal]');
    if (btn) { btn.disabled = true; btn.textContent = t.checking; }
    const sink = document.querySelector('iframe[name="MyBjSink"]');
    let finished = false;
    const challengeOpen = () => [...document.querySelectorAll('iframe[src*="hcaptcha"]')].some((f) => {
      const r = f.getBoundingClientRect();
      if (r.height < 100 || r.width < 100) return false;
      const el = document.elementFromPoint(Math.min(innerWidth - 1, Math.max(0, r.left + r.width / 2)), Math.min(innerHeight - 1, Math.max(0, r.top + r.height / 2)));
      return el === f;
    });
    let challenged = false;
    const finish = (e) => {
      if (finished) return;
      finished = true;
      track(e && e.type === 'load' ? 'mybj_email_ok' : 'mybj_email_timeout');
      // Park the form outside the game screen (still in the document) before re-rendering.
      document.getElementById('MyBjFormHolder').appendChild(signupForm);
      deal();
    };
    if (sink) sink.addEventListener('load', finish, { once: true });
    // No post after a few seconds and no challenge on screen → carry on; keep waiting while a challenge is open.
    const watch = (ms) => setTimeout(() => {
      if (finished) return;
      if (challengeOpen()) { if (!challenged) { challenged = true; track('mybj_captcha'); } watch(1000); } else finish();
    }, ms);
    watch(6000);
    signupForm.target = 'MyBjSink';
    signupForm.dataset.go = '1';
    if (signupForm.requestSubmit) signupForm.requestSubmit(); else signupForm.submit();
  };

  // Safety net: if the drawer is closed but its toggle still says expanded, the theme keeps a grey overlay.
  const resetMenu = () => {
    document.querySelectorAll('header-drawer details').forEach((d) => {
      const sm = d.querySelector(':scope > summary');
      if (!d.hasAttribute('open') && sm && sm.getAttribute('aria-expanded') === 'true') sm.setAttribute('aria-expanded', 'false');
      if (!d.hasAttribute('open')) d.classList.remove('menu-opening');
    });
    if (!document.querySelector('header-drawer details[open]')) document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
  };

  const close = () => {
    // Hide in one step (no fade-out): iOS Safari can leave a fading full-screen layer painted.
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    document.body.style.overflow = '';
    document.documentElement.classList.remove('mybj-open');
    document.documentElement.classList.add('mybj-badge-off');
    resetMenu();
  };
  // Another newsletter form (footer) in use → give the badge back, as before the game.
  document.addEventListener('focusin', (e) => {
    const f = e.target && e.target.form;
    if (f && f !== signupForm && /\/contact/.test(f.getAttribute('action') || '')) document.documentElement.classList.remove('mybj-badge-off');
  });

  document.querySelectorAll('[data-mybj-t]').forEach((el) => { el.textContent = t[el.dataset.mybjT]; });
  if (signupForm) signupForm.querySelector('[data-mybj-email]').placeholder = t.email;
  overlay.querySelector('.mybj__close').setAttribute('aria-label', t.close);
  if (cfg.showFab) fab.hidden = false;
  fab.addEventListener('click', open);

  // Entry in the mobile menu drawer (first item) + direct link mysimplicated.com/#black-friday.
  const drawerList = document.querySelector('#menu-drawer .menu-drawer__navigation > .menu-drawer__menu');
  if (drawerList) {
    const li = document.createElement('li');
    li.innerHTML = `<a href="#black-friday" class="menu-drawer__menu-item list-menu__item link link--text focus-inset mybj-menu-item">${fab.querySelector('svg').outerHTML}${t.fab}</a>`;
    li.firstChild.addEventListener('click', (e) => {
      e.preventDefault();
      // Close the drawer through its own toggle (closeMenuDrawer with our event left the summary
      // aria-expanded="true" in Safari, which keeps the theme's grey ::before overlay on screen).
      const summary = document.querySelector('header-drawer details[open] > summary');
      if (summary) summary.click();
      setTimeout(() => { resetMenu(); open(); }, 300);
    });
    drawerList.prepend(li);
  }
  // Desktop: last item of the inline header menu.
  document.querySelectorAll('.header__inline-menu > .list-menu--inline').forEach((ul) => {
    const li = document.createElement('li');
    li.innerHTML = `<a href="#black-friday" class="header__menu-item list-menu__item link link--text focus-inset mybj-menu-item">${fab.querySelector('svg').outerHTML}<span>${t.fab}</span></a>`;
    li.firstChild.addEventListener('click', (e) => { e.preventDefault(); open(); });
    ul.appendChild(li);
  });
  if (/[?&]ref=share\b/.test(location.search)) track('mybj_from_share');
  if (location.hash === '#black-friday') setTimeout(open, 600);
  window.addEventListener('hashchange', () => { if (location.hash === '#black-friday') open(); });
  overlay.addEventListener('click', async (e) => {
    const t = e.target;
    if (t === overlay || t.closest('[data-mybj-close]')) return close();
    if (busy) return;
    if (t.closest('[data-mybj-deal]')) return askEmail() ? signUp() : deal();
    if (t.closest('[data-mybj-hit]')) return hit();
    if (t.closest('[data-mybj-stand]')) return finish();
    if (t.closest('[data-mybj-prize]')) return renderPrizePick();
    const sh = t.closest('[data-mybj-share]');
    if (sh) return shareWin(sh.dataset.mybjShare);
    if (t.closest('[data-mybj-copy]')) { e.preventDefault(); copyLink(t.closest('[data-mybj-copy]')); return; }
    if (t.closest('[data-mybj-readd]')) { e.preventDefault(); state.declined = false; save(); const cart = await syncCart(); return cart.prizeGone ? renderPrizePick(true) : renderPrizeDone(cart); }
    const pick = t.closest('[data-mybj-pick]');
    if (pick) {
      busy = true;
      state.prize = Number(pick.dataset.mybjPick); save();
      track('mybj_prize_pick');
      try { const cart = await syncCart(); return cart.prizeGone ? renderPrizePick(true) : renderPrizeDone(cart); } finally { busy = false; }
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !overlay.hidden) close(); });

  // Keep the prize line correct whenever the cart changes (drawer/page quantity edits).
  if (!demo) {
    let syncing = false;
    const resync = () => { if (syncing) return; syncing = true; syncCart().finally(() => { syncing = false; }); };
    window.addEventListener('pageshow', resync);
    const origFetch = window.fetch;
    window.fetch = function (url) {
      const p = origFetch.apply(this, arguments);
      if (!syncing && typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) p.then(() => setTimeout(resync, 300));
      return p;
    };
  }
})();
